const Section3 = () => {
  const cardData = [
    {
      heading: "Program 1",
      subheading: "Print and Online ",
      para1:
        " Suitable for average Grade/Year 3 students (about 8 years of age) to adults. The 30 week program has 30 Units and 370 activities.",
      para2:
        " Program 1 covers Spelling, Phonics, Spelling Skills, Synonyms, Antonyms, Compound Words, Grammar and Dictionary Skills and teaches students to read questions carefully and to work independently. ",
    },
    {
      heading: "Program 2",
      subheading: "Print and Online",
      para1:
        " Suitable for average Grade/Year 4 students (about 9 years of age) to adults. The 35 week program has 34 Units and 370 activities.",
      para2:
        "Program 2 covers Spelling, Phonics, Spelling Skills, Synonyms, Antonyms, Syllables, Prefixes, Suffixes, Homophones, Grammar, Punctuation, Dictionary Skills and more. ",
    },
    {
      heading: "Program 3",
      subheading: "Print and Online ",
      para1:
        " Suitable for average Grade/Year 5 students (about 10 years of age) to adults. The 36 week program has 35 Units and 370 activiti",
      para2:
        " Program 3 covers Spelling, Phonics, Spelling Skills, Prefixes, Suffixes, Synonyms, Antonyms, Homophones, Grammar, Punctuation, Editing Skills, Dictionary Skills, Vocabulary Building and more.  ",
    },
    {
      heading: "Program 4",
      subheading: "Print and Online ",
      para1:
        " Suitable for average Grade/Year 6 students (about 11 years of age) to adults. The 35 week program has 34 Units and 280 activities.",
      para2:
        " Program 4 covers Spelling, Phonics, Spelling Skills, Prefixes, Suffixes, Synonyms, Antonyms, Homophones, Grammar, Punctuation, Editing Skills, Dictionary Skills, Vocabulary Building and more.",
    },
    {
      heading: "Program 5",
      subheading: "Print Only",
      para1:
        " Suitable for average Grade/Year 7 students (about 12 years of age) to adults. The 33 week program has 33 Units and 275 activities.",
      para2:
        "Program 5 covers Spelling, Phonics, Spelling Skills, Prefixes, Suffixes, Synonyms, Antonyms, Homophones, Grammar, Punctuation, Editing Skills, Dictionary Skills, Roots of English, Vocabulary Building and more",
    },
  ];

  const CardComponent = ({ data }) => (
    <div className=" flex flex-col justify-center items-center border shadow-2xl  p-2 px-3 rounded-lg gap-y-3">
      <h1 className="font-bold">{data.heading}</h1>
      <h3>{data.subheading}</h3>
      <p className="my-3 px-5 text-sm lg:text-base">{data.para1}</p>
      <p className="my-3 px-5 text-sm lg:text-base">{data.para2}</p>
    </div>
  );
  return (
    <div className=" space-y-4 lg:space-y-7 py-5 lg:w-[90%] mx-auto">
      <h1 className="text-sm lg:text-xl font-bold text-center">Content of the Program</h1>
      <p className="text-center px-5 text-sm lg:text-base">
        You can switch to a more suitable Program if you find you have enrolled
        at the wrong program.
      </p>
      <div className="grid grid-cols-1 gap-6 px-6 sm:grid-cols-3">
        {cardData.map((item) => (
          <CardComponent data={item} />
        ))}
      </div>
    </div>
  );
};

export default Section3;
